/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/blocks/steps.module.scss';

const propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string,
        }),
    ),
    paddedNumber: PropTypes.bool,
    withIndex: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function StepsBlock({
    title = null,
    items = null,
    withIndex = true,
    paddedNumber = true,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
                <div className={styles.items}>
                    <ul>
                        {items.map(({ body }, index) => {
                            const number = index + 1;
                            return (
                                <li key={`steps-item-${index + 1}`} className={styles.item}>
                                    {withIndex ? (
                                        <div className={styles.number}>
                                            {number < 10 && paddedNumber ? `0${number}` : number}
                                        </div>
                                    ) : null}
                                    <div
                                        className={styles.body}
                                        dangerouslySetInnerHTML={{ __html: body }}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}

StepsBlock.propTypes = propTypes;

export default StepsBlock;
